import { render, staticRenderFns } from "./layoutheader.vue?vue&type=template&id=bd95d47a"
import script from "./layoutheader.vue?vue&type=script&lang=js"
export * from "./layoutheader.vue?vue&type=script&lang=js"
import style0 from "./layoutheader.vue?vue&type=style&index=0&id=bd95d47a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports